const budgetKeys = {
  all: ["budget"],
  byId: (id) => [...budgetKeys.all, id],
  byInvoice: (budgetId, invoiceRef) => [
    ...budgetKeys.byId(budgetId),
    invoiceRef,
  ],
};

export default budgetKeys;
